import { Component, Inject, OnInit } from '@angular/core';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { RegulationService } from 'src/app/core/services/regulation';
//import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ChangeViewerLibrary } from 'src/app/core/models/regulation/change-viewer-library';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-info-dialog',
  templateUrl: './edit-info-dialog.component.html',
  styleUrls: ['./edit-info-dialog.component.scss']
})
export class EditInfoDialogComponent implements OnInit {

  isErrorMsg = false;
  regulationLibrary: Array<ChangeViewerLibrary>;
  selectedLibraryId: number;
  prevOrder!: number;
  newOrder: number;
  isLoader = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public itemInfo: AlertDialogModel,
    public dialogRef: MatDialogRef<EditInfoDialogComponent>, private regulationService: RegulationService) {
    this.regulationLibrary = [];
    this.selectedLibraryId = 0;
    this.newOrder = 1;
  }

  ngOnInit(): void {
    this.fetchRegulationLibrary();
  }

  fetchRegulationLibrary(): void {
    this.regulationService.getRegulationLibrary('LibraryName', false).subscribe((data: Array<ChangeViewerLibrary>) => {
      if (data) {
        this.regulationLibrary = data.filter(a => a.isActive);
        this.selectedLibraryId = this.regulationLibrary[0].id;
        this.itemInfo.BodyInput = this.regulationLibrary[0].libraryName;
        this.prevOrder = this.regulationLibrary[0].id;
      }
    });
  }

  changeLibrary(): void {
    const library = this.regulationLibrary.find(a => +a.id === +this.selectedLibraryId);
    this.itemInfo.BodyInput = library?library.libraryName:'';
  }

  onConfirmClick(): void {
    if (!this.itemInfo.BodyInput) {
      this.isErrorMsg = true;
      setTimeout(() => {
        this.isErrorMsg = false;
      }, 3000);
    } else {
      this.itemInfo.Id = this.selectedLibraryId;
      this.dialogRef.close(this.itemInfo);
    }
  }

  updateLibraryOrder(): void {
    this.isLoader = true;
    this.regulationService.updateLibraryOrder(this.prevOrder, this.newOrder).subscribe((result: ChangeViewerLibrary[]) => {
      this.isLoader = false;
      if (result) {
        this.regulationService.regulationLibrary = result.filter(a => a.isActive);
      }
    });
  }
}
